import { Icons } from '@silverfort/sf-components';
import { OpenShowstopperParams } from '../../../context/contexts/ShowstopperProvider';

type tooltipParams = {
    title: string;
    description: string;
    onGetAccessClick: () => void;
};

export const TOOLTIP_PROP_OPTIONS: { [key: string]: tooltipParams } = {
    MFA_MODULE_REQUIRED: {
        title: 'Universal MFA License required',
        description: 'Strengthen security across your environment, protecting users, resources, and protocols.',
        onGetAccessClick: () => {
            window.open('https://www.silverfort.com/mfa-signup/?utm_source=PQL&utm_content=locked', '_blank');
        }
    },
    ITDR_MODULE_REQUIRED: {
        title: 'ITDR License Required',
        description: 'Mitigate vulnerabilities by protecting your identities against risk exposures.',
        onGetAccessClick: () =>
            window.open('https://www.silverfort.com/itdr-signup/?utm_source=PQL&utm_content=locked', '_blank')
    },
    ISPM_MODULE_REQUIRED: {
        title: 'ISPM License Required',
        description: 'Establish a hygienic, secure, and compliant environment.',
        onGetAccessClick: () =>
            window.open('https://www.silverfort.com/ispm-signup/?utm_source=PQL&utm_content=locked', '_blank')
    },
    AUTHENTICATION_FIREWALL_MODULE_REQUIRED: {
        title: 'Authentication Firewall License Required',
        description:
            'Leverage deny policies to enable precise blocking of specific users, resources or weak protocols.',
        onGetAccessClick: () =>
            window.open('https://www.silverfort.com/firewall-signup/?utm_source=PQL&utm_content=locked', '_blank')
    },
    ITDR_AND_ISPM_MODULES_REQUIRED: {
        title: 'ITDR or ISPM Licenses Required',
        description:
            'Investigate, prioritize, and resolve risk across your organization, and respond to threats in real time.',
        onGetAccessClick: () =>
            window.open('https://www.silverfort.com/itdr-ispm-signup/?utm_source=PQL&utm_content=locked', '_blank')
    },
    NHI_PROTECTION_LICENSE_REQUIRED: {
        title: 'Service Account Protection license required',
        onGetAccessClick: () =>
            window.open(
                'https://www.silverfort.com/NHI-protection-signup/?utm_source=PQL&utm_content=locked',
                '_blank'
            ),
        description: 'To get access to this feature, upgrade your license.'
    },
    NHI_ITDR_AND_ISPM_LICENSE_REQUIRED: {
        title: 'Discover ITDR and ISPM',
        onGetAccessClick: () =>
            window.open('https://www.silverfort.com/itdr-ispm-signup/?utm_source=PQL&utm_content=locked', '_blank'),
        description: 'To get access to this feature, upgrade your license.'
    },
    MFA_AND_AUTHENTICATION_FIREWALL_REQUIRED: {
        title: 'Universal MFA or Authentication Firewall License Required',
        onGetAccessClick: () => window.open('https://www.silverfort.com/mfa-firewall-signup/?utm_source=PQL&utm_content=locked'),
        description: 'To get access to this feature, upgrade your license.'
    }
};

export const SHOWSTOPPER_PROP_OPTIONS: { [key: string]: OpenShowstopperParams } = {
    MFA_MODULE_REQUIRED: {
        description: 'Strengthen security across your environment, protecting users, resources, and protocols.',
        icon: Icons.ShieldUser,
        title: 'Discover Universal MFA',
        detailsItems: [
            {
                text: 'Bring your tokens and get agentless end-to-end MFA coverage everywhere'
            },
            {
                text: 'Deploy effortlessly with proxyless architecture and no modifications required'
            },
            {
                text: 'Use any MFA provider with seamless integrations for Microsoft, Okta, Duo, and more'
            }
        ],
        onGetAccessClick: () => {
            window.open('https://www.silverfort.com/mfa-signup/?utm_source=PQL&utm_content=locked', '_blank');
        }
    },
    ITDR_ISPM_MODULES_REQUIRED: {
        title: 'Discover ITDR and ISPM',
        description:
            'Investigate, prioritize, and resolve risk across your organization, and respond to threats in real time.',
        icon: Icons.Target,
        detailsItems: [
            { text: 'Establish a hygienic, secure, and compliant environment' },
            { text: 'Mitigate vulnerable touch points by proactively hardening identity systems' },
            {
                text: 'Identify and block threats, like credential theft and lateral movement, in your environment'
            },
            {
                text: 'Automate responses for account lockdown, threat isolation, and more'
            }
        ],
        onGetAccessClick: () =>
            window.open('https://www.silverfort.com/itdr-ispm-signup/?utm_source=PQL&utm_content=locked', '_blank')
    },
    AUTHENTICATION_FIREWALL_MODULES_REQUIRED: {
        title: 'Discover Authentication Firewall',
        description:
            'Leverage deny policies to enable precise blocking of specific users, resources or weak protocols.',
        icon: Icons.ShieldLock,
        detailsItems: [
            {
                text: 'Automatically deny access when requests violate your policy parameters'
            },
            {
                text: 'Increase environment resilience by blocking weak protocols, like NTLMv1'
            },
            {
                text: 'Segment users to block authentication, preventing unauthorized access'
            }
        ],
        onGetAccessClick: () =>
            window.open('https://www.silverfort.com/firewall-signup/?utm_source=PQL&utm_content=locked', '_blank')
    },
    POLICIES: {
        // todo: verify design and microcopy
        title: 'Policies',
        description: 'Extend protection to all resources using MFA or blocking capabilities.',
        icon: Icons.UserGroupEdit,
        detailsItems: [
            {
                text: 'Manage, enroll, and match your users to singular identities for a seamless and secure experience'
            },
            { text: 'Bring your Tokens and get agentless end-to-end MFA coverage everywhere' },
            { text: 'Create, define, and prioritize policies based on a variety of attributes and parameters' },
            { text: 'Leverage the Authentication Firewall to enable precise blocking of dangerous protocols' }
        ],
        onGetAccessClick: () =>
            window.open('https://www.silverfort.com/mfa-firewall-signup/?utm_source=PQL&utm_content=main', '_blank')
    }
};
